<template>
  <div class="page-wrapper">
    <div class="user-info">
      <div class="user-avarta">
        <van-image width="60px" height="60px" round fit="cover" :src="avatar" />
        <div class="user-button"  @click="unbundle"> 
          {{is365 ? '更换绑定': '退出登录'}}
        </div>
      </div>
      <div class="user-text">
        <div class="head">
          <div class="name">{{realName}}</div>
          <div class="button" v-if="isSwitchAccount" @click="changeRole">
            <img src="@/assets/icons/icon_qh@2x.png" alt="">
            <div class="text">切换账号</div>
          </div>
        </div>
        <div class="head">
          <div class="role">拓客宝身份：{{userInfo.roleName}}</div>
        </div>
        <div class="role" v-if="userInfo.staffPosition">主要岗位：{{userInfo.staffPosition}}</div>
        <div class="role" v-if="userInfo.storeName">所属门店：{{userInfo.storeName}}</div>
        <div class="role" v-if="userInfo.saleShopName">部门：{{userInfo.saleShopName}}</div>
      </div>
    </div>

    <div style="height: 100px; overflow: hidden; margin-top: -70px">
      <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
          <path id="gentle-wave" d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z" />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="-90" y="0" fill="rgba(245,245,245,0.7)" />
          <use xlink:href="#gentle-wave" x="-100" y="3" fill="rgba(245,245,245,0.5)" />
          <use xlink:href="#gentle-wave" x="-100" y="5" fill="rgba(245,245,245,0.3)" />
          <use xlink:href="#gentle-wave" x="-100" y="7" fill="rgb(245,245,245)" />
        </g>
      </svg>
    </div>
    <div class="card">
      <div class="search-box">
        <div class="left">
          <van-field 
            class="id"
            label-width="1em" 
            type="number"
            v-model="form.activityId" 
            label="id" 
            placeholder="请输入id" 
          />
          <van-field 
            class="timer-box" 
            label-width="2.5em" 
            readonly
            label="时间"  
            v-model="time" 
            placeholder="请选择时间"
            @click="isTimeChange = true" 
          />
        </div>
        <div class="right">
          <van-button type="primary" color="#ff6b31" size="mini" @click="search">搜索</van-button>
          <van-button type="primary" color="#ff6b31" size="mini" @click="reset">重置</van-button>
        </div>
      
      </div>
      <div class="item-box">
        <div class="card-item">
          <span class="number">{{personalData.totalSalesVolume || 0}}</span>
          <span>总销售额(元)</span>
        </div>
        <div class="card-item">
          <span class="number">{{personalData.waitVerification || 0}}</span>
          <span>待核销金额(元)</span>
        </div>
        <div class="card-item">
          <span class="number">{{personalData.verificationed || 0}}</span>
          <span>已核销金额(元)</span>
        </div>
        <div class="card-item">
          <span class="number">{{personalData.totalSignUpNum || 0}}</span>
          <span>总报名订单</span>
        </div>
        <div class="card-item">
          <span class="number">{{personalData.waitVerificationNum || 0}}</span>
          <span>待核销订单</span>
        </div>
        <div class="card-item">
          <span class="number">{{personalData.verificationedNum || 0}}</span>
          <span>已核销订单</span>
        </div>
      </div>
      <div class="tips">提示：<br />
        1、默认为全部报名数据 <br />
        2、该显示金额为实际销售金额，而待提现余额是微信平台扣除手续费后的余额（且订单核销后才能提现）</div>
    </div>

    <!-- v-if="personalData.waitRefundNum > 0 && !isTeacher" -->
    <div class="menu-list">
      <van-cell-group inset>
        <van-cell class="refund" 
          title="退款待处理订单" 
          :value="personalData.waitRefundNum" 
          is-link 
          @click="to('/customer-list',5)"
        >
          <div slot="icon" class="icon-box">退<span class="rmb">¥</span></div>
        </van-cell>
      </van-cell-group>
    </div>
    
    <div class="menu-list">
      <van-cell-group inset>
        <van-cell title="活动数据" value="" is-link @click="to('/activity-data')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon1" />
          </div>
        </van-cell>
        <van-cell title="客户列表" value="" is-link @click="to('/customer-list')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon4" />
          </div>
        </van-cell>
        <!-- <van-cell title="商户号资金明细" value="" is-link @click="to('/capitalDetail')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon1" />
          </div>
        </van-cell> -->
        <van-cell title="入网签约" value="" v-if="jjInfo.isJperson" is-link @click="openJj">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon4" />
          </div>
        </van-cell>
        <van-cell v-if="isDistributor || isShopowner" title="提现/入网签约设置" value=""  is-link @click="to('/account')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon2" />
          </div>
        </van-cell>
        <van-cell v-if="isDistributor" title="中奖线索" value="" is-link @click="to('/winning-clue')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon1" />
          </div>
        </van-cell>
        <!-- <van-cell v-if="isDistributor || isShopowner" title="提现设置" value=""  is-link @click="to('/account')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon2" />
          </div>
        </van-cell> -->

        <van-cell  title="微信钱包提现" value="" v-if="isWithdrawSet" is-link @click="to('/withdrawal-home')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon2" />
          </div>
        </van-cell>
        <van-cell  
          title="银联商户号提现" value="" is-link @click="to('/unionpay-balance')" 
          v-if="isWithdrawSet || isDistributor || isShopowner"
        >
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon2" />
          </div>
        </van-cell>
        <van-cell title="扫一扫" value="" is-link @click="to('/scan')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon3" />
          </div>
        </van-cell>
         <!-- <van-cell v-if="isTeacher || isDistributor || isShopowner" title="数据下载" value="" is-link @click="to('/data-download')"> -->
        <van-cell v-if="isTeacher || isDistributor || isShopowner" title="数据下载" value="" is-link @click="to('/data-download')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon1" />
          </div>
        </van-cell>
        <van-cell v-if="isTeacher || isDistributor || isShopowner" title="导出列表" value="" is-link @click="to('/export-list')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon1" />
          </div>
        </van-cell>
        <van-cell  title="操作手册" value="" is-link @click="to('/runBook')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon4" />
          </div>
        </van-cell>
        <van-cell v-if="isTeacher || isDistributor || isShopowner" title="草稿箱" value="" is-link @click="to('/drafts')">
          <div slot="icon">
            <van-image width="20px" height="20px" fit="container" class="menu-icon" :src="icon2" />
          </div>
        </van-cell>
      </van-cell-group>
    </div>
    <van-calendar 
      ref="calendarRef"
      v-model="isTimeChange" 
      allow-same-day
      type="range"
      :min-date="minDate"
      get-container="body"
      color="#FF6B31"
      @close="closeTime"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import moment from 'moment'
import icon1 from '@/assets/icons/list_icon_data@2x.png'
import icon2 from '@/assets/icons/icon-draft-38px@2x.png'
import icon3 from '@/assets/icons/icon-scan-38px@2x.png'
import icon4 from '@/assets/icons/icon-part-in-38px@2x.png'

import avatar from '@/assets/icons/avatar.png'
import { mapGetters } from 'vuex'
import { setToken } from '@/utils/auth'
import { domainName } from '@/utils/constant'
export default {
  name: 'my',
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo',
    ]),
    realName() {
      if (this.userInfo.telephone) {
        return `${this.userInfo.realName}(${this.userInfo.telephone})`
      }else {
        return this.userInfo.realName
      }
    },
    is365() {
      return this.$cache.is365()
    },
  },
  data() {
    return {
      icon1: icon1,
      icon2: icon2,
      icon3: icon3,
      icon4: icon4,
      avatar,
      isSwitchAccount: false,
      isTimeChange: false,
      id: '',
      time: '',
      defaultDate: null,
      minDate: new Date(2010, 0, 1),
      form: {
        activityId: '',
        startTime: '',
        endTime: '',
      },
      personalData: {},
      isWithdrawSet: false,
      jjInfo: {}
    }
  },
  methods: {
    getActivitySignupData() {
      this.$api.h5.getActivitySignupData(this.form)
        .then(res => {
          this.personalData = res.data
        })
    },
    onConfirm(range) {
      const [start, end] = range;
      this.form.startTime = moment(start).format("YYYY-MM-DD") +' 00:00:00';
      this.form.endTime = moment(end).format("YYYY-MM-DD")+' 23:59:59';
      this.time = `${moment(start).format('MM-DD')}-${moment(end).format('MM-DD')}`
      this.isTimeChange = false
      this.search()
    },
    search() {
      this.getActivitySignupData()
    },
    reset() {
      for(let [key,value] of Object.entries(this.form)) {
        this.form[key] = ''
      }
      this.time  = ''
      this.search()
      this.$refs.calendarRef.reset()
    },
    closeTime() {
      this.isTimeChange = false
    },
    refreshLoginUserList() {
      const telephoneMd5 = this.$cache.getLoginInfo().telephoneMd5
      this.$api.common.getLoginUserList({telephoneMd5})
        .then(res => {
          this.$cache.setLoginUserList(res.data || [])
          if (res.data && res.data.length <= 1) {
           this.btnLogin(res.data[0].id)
          } else {
            this.isSwitchAccount = true
          }
        })
    },
    btnLogin(id) {
      let parmes = {
        userId: id,
        wxToken: this.$cache.getLoginInfo().wxToken,
        flag: this.$cache.is365() ? 2 : 1
      };
      this.$api.common.confirmLoginUser(parmes)
        .then(async _ => {
          // 获取部门
          const res = await this.$api.h5.userSaleShopInfo()
          if (res.data.length > 1) {
            this.isSwitchAccount = true
          }
        })
    },
    to(path,state = null) {
      this.$router.push({
        path: path,
        query: {state}
      })
      
    },
    changeRole() {
      this.$router.push({
        path: '/role-change',  
      })
    },
    unbundle() {
      let title = this.is365 ? '更换绑定': '退出登录'
      this.$dialog.confirm({
        title,
        message: `请问是否${title}？<br />退出后再次使用需重新${this.is365 ? '绑定': '登录'}}`,
      }).then( async _ => {
        if (this.is365) {
         const res = await this.$api.h5.unXcxBinding()
         this.$cache.setWxBinDing(false)
          setToken("")
          this.$router.push({
            path: '/applet-login',
            query: {
              source: 'my',
              xcxLink:res.data
            }
          })
        } else {
          await this.$api.h5.unBinding()
          this.$router.push({
            path: '/binding',  
          })
        }
      
      }).catch(_=> {})
    },
    checkIsWithdrawal() {
      this.$api.withdrawal.checkIsWithdrawal()
        .then(res => {
          this.isWithdrawSet = res.data ? true : false
        })
    },
    getFindJJInfo() {
      this.$api.common.findJJInfo()
        .then(res => {
          if (res.success) {
            this.jjInfo = res.data
            // 是否进件人或是经销商并且未配置进件人
            if (res.data.isJperson || res.data.config === 'false') {
              this.show = true
            }
            this.$store.commit('setJjInfo', res.data)
          }
          
        })
    },
    openJj() {
      const { accesserId="001",accesserUserId ='002',url ='url' } = this.jjInfo
      window.open(`${domainName}?accesser_id=${accesserId}&accesser_user_id=${accesserUserId}&h5UserId=${this.userInfo.id}&url=${url}`)
      // window.open(`http://192.168.78.18:9530?accesserId=${accesserId}&accesserUserId=${accesserUserId}&url=${url}`)
    },
  },
  mounted() {
    this.getActivitySignupData()
    this.refreshLoginUserList()
    this.checkIsWithdrawal()
    this.getFindJJInfo()
  }
}
</script>

<style lang="stylus" scoped>
.page-wrapper
  min-height calc(100vh - 50px)
  overflow hidden
.user-info
  height 220px
  background linear-gradient(180deg, #FF8820 0%, #FF6B31 100%)
  display flex
  justify-content flex-start
  align-items center
  padding 0 25px

.user-avarta
  display flex;
  flex-direction column;
  align-items center
  .user-button {
    width: 70px;
    height: 20px;
    line-height: 20px;
    margin-top: 4px;
    color: #FFFFFF;
    font-size: 12px;
    text-align: center;
    border-radius: 30px;
    background: rgba(0,0,0,0.1500);
  }
.user-text
  width 0
  flex 1
  margin-left 12px
  color #ffffff
  .head
    position relative
    font-size 18px;
    .name {
      width: 190px;
    }
    .identity {
      margin-top: 10px
    }
    .button {
      position: absolute;
      top: 0;
      right: -25px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 83px;
      height: 27px;
      background: rgba(0,0,0,0.1500);
      border-radius: 50px 0px 0px 50px;
      img {
        width: 19px;
        height: 19px;
      }
      .text {
        color: #FFFFFF;
        font-size: 12px;
      }
    }
  .role
    font-size 14px
    margin-top 8px

.card {
  margin: 0 16px;
  border-radius: 8px;
  padding: 16px 10px;
  background: #fff;
  .search-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .left {
      display: flex;
      flex: 1;
      margin-right: 5px;
      .id {
        width: 105px;
      }
      .timer-box {
        width: 130px;
      }
      .van-cell {
        padding: 4px 0;
      }
      /deep/ .van-field__label {
        margin-right: 7px;
      }
    }
    .right {
      width: 80px;
    }
  }
  .tips {
    color: #999999;;
    font-size: 12px;
    margin-top: 15px;
  }
  .item-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .card-item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      width: 100px;
      margin-top: 10px;
      color: #323233;
      .number {
        color: #ff6b31;
      }
    }
  }
}
.menu-list
  margin:  10px 0
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 5px;
    color: #F23D20;
    font-size: 12px;
    background: #FFEDEA;
    .rmb {
      display: inline-block;
      font-size: 10px;
      margin-top: -4px;
    }
  }
.menu-icon
  position relative
  top 2px
  margin-right 10px

.refund > >>>.van-cell__value {
  color: #F23D20;
}


// svg css
.waves {
  position:relative;
  width: 100%;
  margin-bottom:-7px; /*Fix for safari gap*/
}

/* Animation */

.parallax > use {
  animation: move-forever 25s cubic-bezier(.55,.5,.45,.5)     infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
  transform: translate3d(-90px,0,0);
  }
  100% { 
    transform: translate3d(68px,0,0);
  }
}
// /*Shrinking for mobile*/
// @media (max-width: 768px) {
//   .waves {
//     height:40px;
//     min-height:40px;
//   }
// }
</style>